import React, { useState } from 'react';

import { Alert } from '@shared/components/bootstrap';

import { Attachments } from '@portal/components/claims/helpers/attachments';
import { Step } from '@portal/components/claims/step';
import { ClaimConsumer, ClaimIssueSelectionConsumer } from '@portal/contexts';

import { Attacher } from './attacher';

const ACCEPT = 'image/*';

export const Photos = () => {
  const [uploading, setUploading] = useState(false);
  return (
    <ClaimConsumer>
      {({ claim: { uuid } }) => (
        <ClaimIssueSelectionConsumer>
          {({ selection: { photos }, onChange }) => (
            <Attacher
              uuid={uuid}
              onAttach={(attachment) => {
                onChange((selection) => ({
                  ...selection,
                  photos: [...selection.photos, attachment],
                }));
              }}
              onDetach={(attachment) => {
                onChange((selection) => ({
                  ...selection,
                  photos: selection.photos.filter(({ id: attachmentID }) => attachmentID !== attachment.id),
                }));
              }}
            >
              {({ attach, detach, loading, error }) => (
                <Step skippable saving={uploading || loading} valid={!!photos.length}>
                  <Step.Title>Please attach any supporting documentation that is relevant to this issue.</Step.Title>
                  <Step.Subtitle>
                    This is optional, but recommended if you experienced any type of financial loss.
                  </Step.Subtitle>
                  {error && <Alert style="danger">{error}</Alert>}
                  <Attachments
                    attachments={photos}
                    accept={ACCEPT}
                    onAttach={attach}
                    onDetach={detach}
                    onUploading={setUploading}
                  />
                </Step>
              )}
            </Attacher>
          )}
        </ClaimIssueSelectionConsumer>
      )}
    </ClaimConsumer>
  );
};
